import { SessionDto } from "@se/platform";
import { ILoggingService, IMessagingService, FormComponent, ValidationSummaryComponent } from "@se/designsystem-core";
import { ISessionService, IAnalyticsService } from "@se/designsystem-core";
import { inject } from "inversify";
import { first } from "rxjs/operators";
import { IFBSFeedbackService } from "../services/interfaces/fbsFeedbackService";

class FeedbackFormComponent extends FormComponent {

    private submitBtn: HTMLButtonElement;
    private otherSuggestionsEl: HTMLDivElement;
    private feedbackPanelToggleEl: HTMLButtonElement;
    private feedbackSurveyLinkEl: HTMLAnchorElement;
    private feedbackPanelEl: HTMLDivElement;
    private feedbackPanelCloseBtn: HTMLButtonElement;
    private feedbackDetailsEl: HTMLTextAreaElement;
    private formEl: HTMLElement;
    private validationMessageEl: HTMLParagraphElement;
    private errorMessageEl: HTMLParagraphElement;
    private successMessageEl: HTMLParagraphElement;
    private feedbackNodeIdEl: HTMLInputElement;
    private accessToken: string;

    constructor(componentEl: HTMLElement,
        protected appInsights: ILoggingService,
        protected messagingService: IMessagingService,
        private sessionService: ISessionService,
        private loggingService: ILoggingService,
        private analyticsService: IAnalyticsService,
        private fbsFeedbackService: IFBSFeedbackService
    ) {
        super(componentEl, messagingService, null, appInsights);

        this.feedbackPanelToggleEl = componentEl.querySelector<HTMLButtonElement>(".js-feedback-paneltoggle");
        this.feedbackSurveyLinkEl = componentEl.querySelector<HTMLAnchorElement>(".js-feedback-survey");
        this.feedbackPanelEl = componentEl.querySelector<HTMLDivElement>(".js-feedback-panel");
        this.submitBtn = componentEl.querySelector<HTMLButtonElement>(".js-feedback-submitbtn");
        this.otherSuggestionsEl = componentEl.querySelector<HTMLDivElement>(".js-feedback-otherSuggestions");
        this.feedbackPanelCloseBtn = componentEl.querySelector<HTMLButtonElement>(".js-feedback-panel-close");
        this.validationMessageEl = componentEl.querySelector<HTMLParagraphElement>(".js-feedback-validationmessage");
        this.feedbackDetailsEl = componentEl.querySelector<HTMLTextAreaElement>(".js-feedback-details");
        this.errorMessageEl = componentEl.querySelector<HTMLParagraphElement>(".js-feedback-submissionerrormessage");
        this.successMessageEl = componentEl.querySelector<HTMLParagraphElement>(".js-feedback-submissionsuccessmessage");
        this.feedbackNodeIdEl = componentEl.querySelector<HTMLInputElement>("#FeedbackNodeId");

        this.formEl = componentEl.querySelector<HTMLFormElement>("form");

        //initial state - hide bot field
        this.otherSuggestionsEl.classList.add("hidden");

        //this.feedbackSurveyLinkEl.addEventListener("click", async (surveyLinkClickedEvent: Event) => {
        //    this.analyticsService.RecordEvent("FBS Survey", new SurveyClickInteractionEvent(this, this.formEl.dataset["service"]., surveyLinkClickedEvent.href));
        //});

        this.feedbackPanelToggleEl.addEventListener("click", async (surveyPanelLinkClickedEvent: Event) => {
            this.ShowOrHideFeedbackForm();
        });
        this.feedbackPanelCloseBtn.addEventListener("click", async (feedbackPanelCloseClickedEvent: Event) => {
            feedbackPanelCloseClickedEvent.preventDefault();
            this.ShowOrHideFeedbackForm();
            this.feedbackPanelToggleEl.focus();
        });


        this.submitBtn.addEventListener("click", async (submitClickedEvent: Event) => {
            submitClickedEvent.preventDefault();
            if (this.ValidateForm() === true) {
                this.submitBtn.disabled = true;
                try {
                    await fbsFeedbackService.SubmitFBSFeedbackForm(this.feedbackDetailsEl.value, parseInt(this.feedbackNodeIdEl.value),this.accessToken).then(sr => {
                        if (sr.wasUnsuccessful) {
                            this.submitBtn.disabled = false;
                            this.errorMessageEl.classList.remove("hidden");
                        }
                        else {
                            this.errorMessageEl.classList.add("hidden");
                            this.successMessageEl.classList.remove("hidden");
                        }
                    });
                } catch (e) {
                    this.submitBtn.disabled = false;
                    this.errorMessageEl.classList.remove("hidden");
                    this.loggingService.LogException(`Error submitting feedback form {e}`);
                }
            }

        });

        this.sessionService.StartSession();
        const onSessionStarted$ = this.sessionService.OnSessionStarted$().pipe(first());
        onSessionStarted$.subscribe(async session =>
            await this.StartSession(session)
        );
    }

    private ShowOrHideFeedbackForm() {
        if (this.feedbackPanelEl.classList.contains("hidden")) {
            this.feedbackPanelEl.classList.remove("hidden");
            //this.analyticsService.RecordEvent("FBS Feedback Form Shown", new ClickInteractionEvent(this, this.formEl.dataset["service"]., surveyLinkClickedEvent.href));
        }
        else {
            this.feedbackPanelEl.classList.add("hidden");

        };
        this.feedbackPanelToggleEl.setAttribute("aria-expanded", this.feedbackPanelEl.classList.contains("hidden") ? "false" : "true");
    }

    private ValidateForm(): boolean {
        if (this.feedbackDetailsEl.textLength >= 10) {
            this.validationMessageEl.classList.add("hidden");
            return true;
        }
        this.validationMessageEl.classList.remove("hidden");
        return false;
    }

    private async StartSession(session: SessionDto) {
        if (session.accessToken == null) {
            this.appInsights.LogMessage('feedbackForm:StartSession error: No access token');
        }
        this.accessToken = session.accessToken;
    }
}

export { FeedbackFormComponent };
